import React, { useMemo } from 'react';
import { useAtom, useAtomValue } from 'jotai';
import { Tooltip, type SelectProps } from 'antd';
import { Nav } from './Nav';
import { dataSourceMap, type DataSource } from '../../utils';
import { useResetState } from '../hooks';
import * as Styled from './styled';
import * as atoms from '../atom';

export const DataSourceSelector = () => {
  const disabledDataSources = useAtomValue(atoms.disabledDataSources);
  const [dataSource, setDataSource] = useAtom(atoms.dataSource);
  const callbacks = useAtomValue(atoms.callbacks);
  const { reset } = useResetState();

  const options = useMemo(() => {
    const validOptions = [] as NonNullable<SelectProps['options']>;
    for (const [value, label] of Object.entries(dataSourceMap)) {
      const disabled = disabledDataSources?.includes(value as DataSource);
      validOptions.push({
        label: disabled ? <Tooltip title="Please contact your Conviva representative to activate">{label}</Tooltip> : label,
        value,
        disabled,
      });
    }
    return validOptions;
  }, [disabledDataSources]);

  const handleChange = (value) => {
    setDataSource(value);
    reset();
    // notify outside component that data source is changed
    // then outside component can update the filter meta and saved filter list
    callbacks.onDataSourceChange?.(value);
  };

  return (
    <Styled.Container>
      <Styled.Select
        bordered={false}
        value={dataSource}
        onChange={handleChange}
        options={options}
        getPopupContainer={e => e.parentElement}
      />
      <Styled.Divider />
      <Nav />
    </Styled.Container>
  );
}